import { GlForm, GlModal, GlFormInput, GlFormGroup } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import csrf from '~/lib/utils/csrf';
import { __, s__, sprintf } from '~/locale';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { getParameterByName } from '~/lib/utils/url_utility';
import { WIKI_RESTORE_VERSION_ACTION, WIKI_RESTORE_VERSION_LABEL, WIKI_RESTORE_VERSION_TRACKING_LABEL } from '../constants';
const trackingMixin = Tracking.mixin({
    label: WIKI_RESTORE_VERSION_TRACKING_LABEL
});
export default {
    name: 'RestoreVersionModal',
    components: {
        GlForm,
        GlFormGroup,
        GlFormInput,
        GlModal
    },
    mixins: [
        trackingMixin
    ],
    inject: {
        pageInfo: {
            default: null
        }
    },
    props: {
        modalId: {
            type: String,
            required: true
        }
    },
    data () {
        const versionNumber = getParameterByName('version_number');
        const restoredFrom = versionNumber ? sprintf(s__('Wiki|v%{version}'), {
            version: versionNumber
        }) : s__('Wiki|old version');
        return {
            restoredFrom,
            commitMessage: sprintf(s__('Wiki|Restored from %{from}'), {
                from: restoredFrom
            })
        };
    },
    computed: {
        primaryAction () {
            return {
                text: this.$options.i18n.restoreText,
                attributes: {
                    variant: 'confirm',
                    type: 'submit',
                    form: 'wiki-restore-version-form'
                }
            };
        },
        cancelAction () {
            return {
                text: this.$options.i18n.cancelText
            };
        },
        csrfToken () {
            return csrf.token;
        }
    },
    methods: {
        async handleRestore (e) {
            e.preventDefault();
            if (e.type !== 'submit') {
                return;
            }
            this.track(WIKI_RESTORE_VERSION_ACTION, {
                label: WIKI_RESTORE_VERSION_LABEL,
                extra: {
                    project_path: this.pageInfo.path,
                    restored_from: this.restoredFrom
                }
            });
            // Wait until form field values are refreshed
            await this.$nextTick();
            e.target.submit();
        }
    },
    i18n: {
        cancelText: __('Cancel'),
        restoreText: __('Restore'),
        restoreModalTitle: s__('Wiki|Restore this version'),
        commitMessageLabel: s__('Wiki|Commit message'),
        commitMessagePlaceholder: s__('Wiki|Enter commit message')
    }
};
